import type { FaireProductEntity } from "../../entity_types/product";

export const p_juz3eqdxkx: FaireProductEntity = {
  token: "p_juz3eqdxkx",
  type: "product",
  name: "rocky's matcha Essential Tea Kit",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/71212addd2f4db5d2c164333e7c6f718aad66cc5f2461559456c320258f12a69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/867ce8899713906f5d91d2bee37e2cbe9abf8659af2822fb50063105958ee112.jpeg",
    "https://cdn.faire.com/fastly/b4045f9d72b53f3f9c8a1ad27fe6908fe90e37f392cdae1e0354ee64a7defbf9.jpeg",
    "https://cdn.faire.com/fastly/1e7d557d88e84cd6fbe4d335a590770037988e3650be3f8228d9239eeb8144de.jpeg",
    "https://cdn.faire.com/fastly/7fe62f1f8ad4ef2e256efef4767bb4ce9dd795f60cdec3e7addf516ba71bf165.jpeg",
    "https://cdn.faire.com/fastly/67ea8f6d1f65bdd4485678a492ec413faeaeddeb9a1dc10567e7af20bbe36a3a.jpeg",
    "https://cdn.faire.com/fastly/8b80541a7f294781941db3be6e100e5fd1dde598a1731594714c583ded3bcf58.jpeg",
    "https://cdn.faire.com/fastly/cb58fea56bbd28236702c8e9c047aadd1c2af12cbd8de1282fcf26df8efb8416.png",
    "https://cdn.faire.com/fastly/d50b605e59b42de64f037f614763ba30ba72652ad661419403102d6f92a6e81e.jpeg",
    "https://cdn.faire.com/fastly/69d0377d33150936561fd971163a3515ff8c4edb27a989749315f712f7f077e7.png",
    "https://cdn.faire.com/fastly/a89cd26084e60922d3e26e530199b7df9f7b31de05523ffa34682cb82d0919a6.jpeg"
  ],
  priceDollars: 38,
  description: "rocky's matcha is proud to offer our essential matcha tea kit that includes all of the matcha tools needed to make the perfect cup of matcha at home or on the road.\n\nEach rocky's matcha essential tea kit includes a Rocky's Matcha chasen matcha whisk, a ceramic whisk stand, a tea sifter, a Rocky's Matcha measuring spoon, and a tin of rocky's matcha Osada Ceremonial Blend Matcha (20g).\n\n• rocky's matcha chasen matcha whisk\n• white ceramic whisk stand\n• tea sifter\n• rocky's matcha measuring spoon\n• rocky's matcha Osada Ceremonial Blend Matcha (20g tin)",
  tags: [],
  msrpDollars: 76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:21.185Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
